import { User, UserSearchResult } from '../../models/user.model';

export interface UserSortState {
  active: 'name' | 'email' | 'createdAt' | 'carCount' | 'realEstateCount' | null;
  direction: 'asc' | 'desc' | null;
}

export interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

export interface UsersState {
  query: User | undefined;
  users: UserSearchResult[] | undefined;
  user: User | undefined;
  loading: boolean;
  isSaving: boolean;
  error: any;
  savingError: any;
  sort: UserSortState;
  pagination: PaginationState;
  isUserMapView: boolean;
}

export const initialUSerState: UsersState = {
  query: undefined,
  users: undefined,
  user: undefined,
  loading: false,
  isSaving: false,
  error: null,
  savingError: null,
  sort: {
    active: null,
    direction: null,
  },
  pagination: {
    pageIndex: 0,
    pageSize: 12,
  },
  isUserMapView: false,
};
